import React, { useState, useEffect } from "react";
import { usePostApiMutation, usePutApiMutation } from "../../utils/customer/customerTaskTable";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import {
  useFetchCompanyStructureQuery,
  useLazyFetchCompanyDataIdQuery,
  useLazyFetchCompanyStructureQuery,
} from "../../utils/company/companypermissions";
import InputComponent from "../UniversalComponents/InputComponent";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import BasicSelect from "../Task/BasicSelect";

import { ReactComponent as LineSvg } from "../../assets/images/icons/Line.svg";
import { COMPANY_ADD, UPDATE_SECTION_FIELD } from "../../utils/constants";
import { FormControlLabel, Switch } from "@mui/material";
import styled from "@mui/material/styles/styled";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import { useParams } from "react-router-dom";

const AdvancedCompany = ({ ischeck = false, setEditButtonState1, editButtonState1 }) => {
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  // const [formData, setFormData] = useState(advancedCompany || {});
  const [advancedCompanyHeader, setAdvancedCompanyHeader] = useState([]);
  const [isCompanyCreated, setIsCompanyCreated] = useState(false);
  const [CompanyName, setCompanyName] = useState({});
  const [advancedCompany, setAdvancedCompany] = useState({});

  const [showConfirmation, setShowConfirmation] = useState(false);

  const data = useParams();

  const [
    AdvancedCompanyValue,
    {
      data: AdvancedcompanyHeaderData,
      isLoading: AdvancedcompanyHeaderLoading,
      isError: AdvancedcompanyHeaderDataError,
      error: AdvancedcompanyHeaderErrorData,
      isSuccess: AdvancedcompanyHeaderDataSuccess,
    },
  ] = useLazyFetchCompanyStructureQuery();

  const [
    AdvancedCompanyAddUpdate,
    {
      isLoading: updateCompanyAdvancedLoading,
      isSuccess: updateCompanyAdvancedSuccess,
      data: updateCompanyAdvancedData,
      isError: updateCompanyAdvancedError,
      error: updateCompanyAdvancedErrorData,
    },
  ] = usePutApiMutation();

  const [
    AdvancedPageValue,
    { data: companyEditData, isLoading: isCompanyEditDataLoading, error: companyEditDataError, refetch },
  ] = useLazyFetchCompanyDataIdQuery();

  const handleTempFunc = async () => {
    try {
      const response = await AdvancedPageValue({ id: data?.id, page: "Advanced_page" || "" });
      if (response?.data?.success) {
        const filterData = transformFormData(response?.data?.data);
        setAdvancedCompany(filterData);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    //loading
    if (AdvancedcompanyHeaderLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (AdvancedcompanyHeaderDataSuccess) {
      if (AdvancedcompanyHeaderData.success) {
        setAdvancedCompanyHeader(AdvancedcompanyHeaderData?.data);
      }
    }

    // catch block
    if (AdvancedcompanyHeaderDataError) {
      dispatch(pushAlert({ message: AdvancedcompanyHeaderErrorData?.data?.message, type: "danger", visible: true }));
    }
  }, [AdvancedcompanyHeaderDataSuccess, AdvancedcompanyHeaderDataError, AdvancedcompanyHeaderData]);

  useEffect(() => {
    // Show loader while updating
    if (updateCompanyAdvancedLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    // Handle success response
    if (updateCompanyAdvancedSuccess) {
      dispatch(
        pushAlert({
          message: updateCompanyAdvancedData?.message || "Company updated successfully",
          type: updateCompanyAdvancedData?.success ? "success" : "danger",
          visible: true,
        })
      );

      if (updateCompanyAdvancedData?.success) {
        handleTempFunc();
        if (!ischeck) {
          setAdvancedCompany({});
        }
      }
    }

    // Handle error response
    if (updateCompanyAdvancedError) {
      dispatch(
        pushAlert({
          message: updateCompanyAdvancedErrorData?.data?.message || "Failed to update company",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [updateCompanyAdvancedLoading, updateCompanyAdvancedSuccess, updateCompanyAdvancedError]);

  useEffect(() => {
    AdvancedCompanyValue({
      page: "Advanced_page",
    });
  }, []);

  const transformFormData = (data) => {
    const formattedData = {};

    // 1. Convert fixed_company_info to general_info
    if (data.fixed_company_info) {
      const generalInfo = [];

      for (const [key, value] of Object.entries(data.fixed_company_info)) {
        if (key === "business_category") {
          generalInfo.push({
            key,
            value: value.default_value ?? "",
          });
        } else {
          generalInfo.push({
            key,
            value: value ?? "",
          });
        }
      }

      formattedData["general_info"] = generalInfo;
    }

    // 2. Convert each section to desired format
    if (Array.isArray(data.sections)) {
      data.sections.forEach((section) => {
        const sectionKey = section.section_key;
        const fieldValues = [];

        section.fields.forEach((field) => {
          fieldValues.push({
            key: field.key,
            value: field.value ?? field.default_value ?? "",
          });
        });

        formattedData[sectionKey] = fieldValues;
      });
    }

    return formattedData;
  };

  useEffect(() => {
    handleTempFunc();
  }, []);

  const handleFieldChange = (sectionKey, fieldKey, newValue) => {
    setAdvancedCompany((prev) => {
      const existingFields = prev[sectionKey] || [];

      const updatedFields = existingFields.some((f) => f.key === fieldKey)
        ? existingFields.map((f) => (f.key === fieldKey ? { ...f, value: newValue } : f))
        : [...existingFields, { key: fieldKey, value: newValue }];

      return {
        ...prev,
        [sectionKey]: updatedFields,
      };
    });
  };

  const getFieldValue = (advancedCompany, sectionKey, fieldKey) => {
    return advancedCompany?.[sectionKey]?.find((field) => field.key === fieldKey)?.value ?? "";
  };
  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 42,
      height: 26,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#65C466",
            opacity: 1,
            border: 0,
            ...theme.applyStyles("dark", {
              backgroundColor: "#2ECA45",
            }),
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color: theme.palette.grey[100],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[600],
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.7,
          ...theme.applyStyles("dark", {
            opacity: 0.3,
          }),
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    })
  );

  const renderFieldByType = (field, sectionKey, handleFieldChange) => {
    const id = field.key;
    const currentValue = getFieldValue(advancedCompany, sectionKey, field.key);
    const isEditDisabled = editButtonState1 && ischeck;

    switch (field.type) {
      case "text":
      case "string":
        return (
          <InputComponent
            id={id}
            type="text"
            placeholder={field.label}
            value={currentValue || ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            mandatory={field.mandatory ? true : false}
            error={!currentValue ? `${field.label} field is required` : ""}
            className={`w-full my-2 border-[#d2d5d7] rounded-md  ${ischeck && isEditDisabled && "cursor-not-allowed bg-gray-200"} `}
            isDisabled={ischeck && isEditDisabled ? true : false}
          />
        );
      case "int":
      case "integer":
      case "number":
      case "float":
        return (
          <input
            id={id}
            type="number"
            value={currentValue ?? field.value ?? ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            className={`w-full my-2 border-[#d2d5d7] rounded-md  ${ischeck && isEditDisabled && "cursor-not-allowed bg-gray-200"} `}
            isDisabled={ischeck && isEditDisabled ? true : false}
          />
        );
      case "boolean":
        return (
          // <input
          //   id={id}
          //   type="checkbox"
          //   checked={currentValue ?? field.value}
          //   onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.checked)}
          //   className="h-5 w-5"
          // />
          <FormControlLabel
            control={
              <IOSSwitch
                checked={currentValue ?? field.value}
                onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.checked)}
                disabled={ischeck && isEditDisabled ? true : false}
              />
            }
          />
        );
      case "date":
        return (
          <DatePickerComponent
            id={id}
            value={currentValue ?? field.value ?? ""}
            onChange={(date) => handleFieldChange(sectionKey, field.key, date)}
            className="w-full px-3 py-2 rounded-md border-[#d2d5d7]"
            placeholder="Select date"
          />
        );
      case "Dropdown":
      case "select":
        return (
          <div className="w-full  border-b-[1px] rounded-lg">
            <BasicSelect
              isMulti
              showSearch={field?.value?.length > 6 ? true : false}
              size="large"
              options={
                field.value?.map((option) => ({
                  label: option,
                  value: option,
                })) || []
              }
              id={id}
              selectedOptions={
                field.value
                  ?.filter((val) =>
                    advancedCompany?.[sectionKey]?.some((item) => item.key === field.key && item.value === val)
                  )
                  .map((val) => ({
                    label: val,
                    value: val,
                  })) || []
              }
              onEditColor={editButtonState1}
              disabled={ischeck && editButtonState1 ? true : false}
              onChange={(e) => handleFieldChange(sectionKey, id, e.target.value)}
              className="w-full px-3 py-2 border rounded-md bg-gray-100"
            />
          </div>
        );
      default:
        return (
          <input
            id={id}
            type="text"
            value={currentValue ?? field.value ?? ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            className="w-full px-3 py-2 border rounded-md"
          />
        );
    }
  };
  const buildPayload = (formData) => {
    const fields = [];

    for (const sectionKey in formData) {
      // Remap general_info to fixed_company_info
      const actualSectionKey = sectionKey === "general_info" ? "fixed_company_info" : sectionKey;

      formData[sectionKey].forEach((field) => {
        fields.push({
          section_key: actualSectionKey,
          key: field.key,
          value: field.value,
          ...(field.default_value !== undefined && { default_value: field.default_value }),
          ...(field.field_order !== undefined && { field_order: field.field_order }),
        });
      });
    }

    return {
      company_id: data?.id,
      fields,
    };
  };
  console.log("parms", data);

  const updateCompanyAdvanced = buildPayload(advancedCompany);

  const handleAdvanceSubmit = (e) => {
    e.preventDefault();
    setEditButtonState1(() => !editButtonState1);

    if (!editButtonState1) {
      if (ischeck) {
        const response = AdvancedCompanyAddUpdate({
          data: updateCompanyAdvanced,
          url: `${UPDATE_SECTION_FIELD}Advanced_page`,
        });
        console.log("responsedata vinay", response);
      }
    }
  };
  const handleClear = () => {
    setAdvancedCompany({});
    setShowConfirmation((prev) => !prev);
  };
  return (
    <>
      <form
        onSubmit={handleAdvanceSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            // Find the next focusable element
            const focusableElements =
              'button, [href],text,string,number,dropdown, input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const form = e.target.form;
            const focusable = [...form.querySelectorAll(focusableElements)];
            const index = focusable.indexOf(e.target);
            // Move to next element or back to first if at end
            const nextElement = focusable[index + 1] || focusable[0];
            nextElement.focus();
            return false;
          }
        }}
        className="w-full"
      >
        <div className="flex items-start justify-between flex-col w-full h-full px-3 pt-3">
          <div className="flex items-start justify-start flex-col w-full h-fit gap-4">
            {/* sections */}
            <div className="w-full">
              {/* Fixed Company Info Sections */}
              {advancedCompanyHeader?.advanced_info?.sections_order?.map((sectionKey) => {
                const section = advancedCompanyHeader.advanced_info[sectionKey];
                const fieldKeys = [...(section.fields_order1 || []), ...(section.fields_order2 || [])];

                return (
                  <div
                    key={sectionKey}
                    className="flex flex-col items-center justify-start w-full border-[1px] border-[#D2DAE1] rounded-md p-4 gap-3 mb-4"
                  >
                    {/* Section Name */}
                    <div className="flex items-center justify-start w-full">
                      <span className="mr-2 text-[#2E333D] font-poppins text-base font-semibold capitalize">
                        {section.label}
                      </span>
                      <LineSvg />
                    </div>

                    {/* Fields */}
                    {fieldKeys.length > 0 ? (
                      <div className="w-full grid grid-cols-2 gap-x-28 gap-y-2">
                        {fieldKeys.map((fieldKey) => {
                          const field = section.fields?.[fieldKey];
                          if (!field) return null;

                          return (
                            <div key={fieldKey} className="flex items-center justify-between gap-4">
                              <label className="w-3/5 text-[#434852] font-poppins text-base font-normal capitalize">
                                {field.label}
                              </label>
                              {renderFieldByType(field, sectionKey, handleFieldChange)}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-red-500 font-medium">No fields found in this section.</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Buttons */}
          <div className="w-full bg-white flex justify-start py-3 mt-2 gap-3 sticky bottom-0 ">
            <button
              onClick={(e) => (editButtonState1 ? e.preventDefault() : setShowConfirmation((prev) => !prev))}
              type="button"
              className=" w-24 h-8 flex justify-center items-center shrink-0 text-base rounded-md border text-[#383838] border-[#D2DAE1] bg-[#e6e5e5] hover:bg-[#f3f3f3]"
            >
              Clear
            </button>
            <button
              type="submit"
              className=" w-24 h-8 flex justify-center items-center shrink-0 text-base rounded-md border text-[#FFFFFF] border-[#123251] bg-[#1D4469] hover:bg-[#1b3c5c]"
            >
              {ischeck ? (editButtonState1 ? "Edit" : "Update") : "Save"}
            </button>
          </div>
        </div>
      </form>

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={handleClear}
          onClose={() => setShowConfirmation((prev) => !prev)}
          title="Discard"
          message={`Are you sure want to discard this data ?`}
          confirmVariant="discard"
          iconVariant="discard"
          confirmText="Yes"
          cancelText="No"
        />
      )}
    </>
  );
};

export default AdvancedCompany;
